// Generated from the Greater Maricopa Business Alliance public member directory.
// Source: https://www.chamberorganizer.com/maricopachamber/directory_all
// Last verified: 2026-09-03

export const CHAMBER_MEMBERS = [
  {
    "name": "911 Air Repair LLC",
    "category": "Home Services",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "480-360-1234",
    "website": "https://www.911-ac.com/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_911ac",
    "memberSince": "2017"
  },
  {
    "name": "A A Raymond Law Firm",
    "category": "Legal & Financial",
    "location": "44400 Honeycutt Rd, suite 110, Maricopa, AZ 85138",
    "phone": "520-483-9100",
    "website": "",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_AARLawFirm",
    "memberSince": "2020"
  },
  {
    "name": "AAA Smart Security",
    "category": "Home Services",
    "location": "8312 S Hardy Rd, Bldg F, Suite 104, Tempe, AZ 85284",
    "phone": "480-390-8398",
    "website": "https://docu.team/mtiodew/index.php?v=lp&store=165968",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_A3SmartBusiness",
    "memberSince": "2025"
  },
  {
    "name": "ACP Painting, LLC",
    "category": "Home Services",
    "location": "19342 N Maricopa Rd., Maricopa, AZ 85139",
    "phone": "480-785-6323",
    "website": "http://www.acppaintingllc.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_ACPPainting",
    "memberSince": "2014"
  },
  {
    "name": "Actually Social",
    "category": "Marketing & Business Services",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "602-882-7918",
    "website": "http://www.actuallysocialmedia.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_ActuallySocial",
    "memberSince": "2021"
  },
  {
    "name": "Adobe Blinds and More",
    "category": "Home Services",
    "location": "41600 W Smith Enke Rd, Building 2, Suite 110, Maricopa, AZ 85138",
    "phone": "520-635-3543",
    "website": "http://www.adobeblinds.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_adobeblinds",
    "memberSince": "2012"
  },
  {
    "name": "Against Abuse, Inc",
    "category": "Community & Nonprofit",
    "location": "119 N Florence St, Casa Grande, AZ 85122",
    "phone": "520-836-1239",
    "website": "http://www.against-abuse.org",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_AAI",
    "memberSince": "2008"
  },
  {
    "name": "Ak-Chin Southern Dunes Golf Club",
    "category": "Recreation & Entertainment",
    "location": "48456 W. Hwy 238, Maricopa, AZ 85139",
    "phone": "520-568-2000",
    "website": "http://www.akchinsoutherndunes.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_bwilson_ak-chin",
    "memberSince": "2008"
  },
  {
    "name": "Al and Rileys Air Conditioning and Sheet Metal inc.",
    "category": "Home Services",
    "location": "40 N Brown ave, CASA GRANDE, AZ 85122",
    "phone": "520-836-8450",
    "website": "http://alandrileys.com/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_alandrileys",
    "memberSince": "2026"
  },
  {
    "name": "Aloe Property Management",
    "category": "Real Estate & Housing",
    "location": "41810 W Cactus Flower, Maricopa, AZ 85138",
    "phone": "602-854-9884",
    "website": "http://www.aloepm.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_desertcanyonaz",
    "memberSince": "2021"
  },
  {
    "name": "Alpha Omega Law Offices",
    "category": "Legal & Financial",
    "location": "41704 W. Smith-Enke Rd., Suite# 100, Maricopa, AZ 85139",
    "phone": "480-658-7495",
    "website": "http://www.AlphaOmegaLawOffices.com",
    "chamberProfile": "",
    "memberSince": "2026"
  },
  {
    "name": "American Legion Post 133",
    "category": "Community & Nonprofit",
    "location": "41614 W. Smith-Enke Rd., Ste 110, Maricopa, AZ 85138",
    "phone": "586-530-5730",
    "website": "http://alpost133az.org",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_Vets",
    "memberSince": "2011"
  },
  {
    "name": "Arf-Anage",
    "category": "Pets & Animal Care",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "",
    "website": "",
    "chamberProfile": "",
    "memberSince": "2026"
  },
  {
    "name": "Arroyo Grille",
    "category": "Food & Drink",
    "location": "48456 W. Hwy 238, Maricopa, AZ 85139",
    "phone": "520-568-2000",
    "website": "http://www.akchinsoutherndunes.com/arroyo_grille/",
    "chamberProfile": "",
    "memberSince": "2008"
  },
  {
    "name": "AZ Law Now, Injury Attorneys",
    "category": "Legal & Financial",
    "location": "21300 N John Wayne Pkwy Suite 109-B, Maricopa, AZ 85139",
    "phone": "520-217-8821",
    "website": "https://azlawnow.com/locations/maricopa-injury-lawyer/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_azlawnowcopa",
    "memberSince": "2026"
  },
  {
    "name": "Be Awesome Youth Coalition",
    "category": "Community & Nonprofit",
    "location": "P.O. Box 144, Maricopa, AZ 85139",
    "phone": "520-428-6633",
    "website": "http://beawesomeyouth.life",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_beawesome",
    "memberSince": "2024"
  },
  {
    "name": "Black Maricopa Chamber of Commerce",
    "category": "Community & Nonprofit",
    "location": "PO Box 622, Maricopa, AZ 85139",
    "phone": "615-935-4451",
    "website": "http://www.blackmaricopacc.com",
    "chamberProfile": "",
    "memberSince": "2025"
  },
  {
    "name": "Bloom In Grace Counseling",
    "category": "Health & Care",
    "location": "44480 W. Honeycutt Rd, Suite 103, Maricopa, AZ 85138",
    "phone": "480-810-8333",
    "website": "http://big-counseling.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_BIGCounseling",
    "memberSince": "2026"
  },
  {
    "name": "Blossom Digital Marketing",
    "category": "Marketing & Business Services",
    "location": "408 N. Sacaton St., Suite A, Casa Grande, AZ 85122",
    "phone": "520-423-8671",
    "website": "https://blossommarketingagency.com/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_BDM",
    "memberSince": "2024"
  },
  {
    "name": "Boys & Girls Club of the Sun Corridor",
    "category": "Community & Nonprofit",
    "location": "PO Box 10291, Casa Grande, AZ 85130",
    "phone": "520-477-1131",
    "website": "http://www.bgcsuncorridor.org",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_BoysnGirlsClub",
    "memberSince": "2020"
  },
  {
    "name": "Bungalows on Bowlin",
    "category": "Real Estate & Housing",
    "location": "44900 W. Bowlin Rd, Maricopa, AZ 85139",
    "phone": "480-719-5780",
    "website": "http://www.bungalowsonbowlin.com/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_Bungalows",
    "memberSince": "2026"
  },
  {
    "name": "Business Expansion & Development Services LLC",
    "category": "Marketing & Business Services",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "602-577-2351",
    "website": "http://busexpdev.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_busexpdev",
    "memberSince": "2023"
  },
  {
    "name": "C&N Roofing",
    "category": "Home Services",
    "location": "1454 E. Corona Ave, Phoenix, AZ 85040",
    "phone": "602-636-1144",
    "website": "http://www.cnroofing.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_cnroofingjohn",
    "memberSince": "2024"
  },
  {
    "name": "CAC Small Business Development Center",
    "category": "Community & Nonprofit",
    "location": "17945 N. Regent Dr., Maricopa, AZ 85138",
    "phone": "520-494-6450",
    "website": "http://cacsbdc.azsbdc.net/",
    "chamberProfile": "",
    "memberSince": "2006"
  },
  {
    "name": "Carefree Covered RV Storage",
    "category": "Home Services",
    "location": "45760 W Estrella Pkwy, Maricopa, AZ 85139",
    "phone": "520-701-1601",
    "website": "http://www.carefreecoveredrvstorage.com/",
    "chamberProfile": "",
    "memberSince": "2025"
  },
  {
    "name": "Central Arizona College - Maricopa Campus",
    "category": "Education & Childcare",
    "location": "17945 Regent Drive, Maricopa, AZ 85138",
    "phone": "480-677-7875",
    "website": "http://www.centralaz.edu/Central_Campuses/Maricopa_Center.htm",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_CACMaricopa",
    "memberSince": "2003"
  },
  {
    "name": "Chris Cahall Agency of American Family Insurance",
    "category": "Legal & Financial",
    "location": "19756 N Maricopa Rd, Suite 112, Maricopa, AZ 85139",
    "phone": "520-350-2500",
    "website": "http://chriscahallagency.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_ChrisCahall",
    "memberSince": "2011"
  },
  {
    "name": "Church of Celebration",
    "category": "Community & Nonprofit",
    "location": "20987 N John Wayne Parkway, Suite B104 PMB 317, Maricopa, AZ 85139",
    "phone": "520-494-7714",
    "website": "http://www.churchofcelebration.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_cofcelebration",
    "memberSince": "2009"
  },
  {
    "name": "City of Maricopa",
    "category": "Community & Nonprofit",
    "location": "39700 W Civic Center Plaza, Maricopa, AZ 85138",
    "phone": "520-316-6811",
    "website": "https://www.maricopa-az.gov/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_cityofcopa",
    "memberSince": "2025"
  },
  {
    "name": "City of Maricopa Council Member",
    "category": "Community & Nonprofit",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "602-574-5803",
    "website": "",
    "chamberProfile": "",
    "memberSince": "2020"
  },
  {
    "name": "Cold Beer and Cheeseburgers",
    "category": "Food & Drink",
    "location": "20350 N John Wayne Parkway Ste 160, Maricopa, AZ 85138",
    "phone": "520-509-4766",
    "website": "http://www.coldbeers.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_CBCheeseburgers",
    "memberSince": "2025"
  },
  {
    "name": "Commercial Properties Inc",
    "category": "Real Estate & Housing",
    "location": "1729 N Trekell Rd Ate 114, Casa Grande, AZ 85122",
    "phone": "480-634-2340",
    "website": "http://www.cpiaz.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_CPI",
    "memberSince": "2024"
  },
  {
    "name": "Community Of Hope Church",
    "category": "Community & Nonprofit",
    "location": "45295 W Honeycutt Ave, Maricopa, AZ 85139",
    "phone": "520-252-6381",
    "website": "http://www.cohmaricopa.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_Hope",
    "memberSince": "2006"
  },
  {
    "name": "Copa Farmer's Market",
    "category": "Recreation & Entertainment",
    "location": "37362 W Capri Ave, Maricopa, AZ 85138",
    "phone": "480-306-1958",
    "website": "http://www.copafarmersmarket.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_copafarmersmkt",
    "memberSince": "2025"
  },
  {
    "name": "Copa Flats",
    "category": "Real Estate & Housing",
    "location": "17485 N. Porter Rd, Maricopa, AZ 85138",
    "phone": "520-371-5535",
    "website": "http://www.copaflatsaz.com/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_CopaFlats",
    "memberSince": "2026"
  },
  {
    "name": "Copacetic Magazine",
    "category": "Marketing & Business Services",
    "location": "19428 N. Maricopa Rd., Suite 103, Maricopa, AZ 85138",
    "phone": "520-568-4298",
    "website": "https://www.pinalcentral.com/eedition/copacetic/",
    "chamberProfile": "",
    "memberSince": "2024"
  },
  {
    "name": "Cox Communications",
    "category": "Utilities & Communications",
    "location": "1440 E 15th St, Tuscon, AZ 85719",
    "phone": "480-270-8761",
    "website": "https://www.cox.com/residential/internet/fiber.html?utm_id=lfo_sem_goog_std_nc_gen_fiber_ifp_brand_exact&sc_id=lfo_sem_goog_std_nc_gen_fiber_ifp_brand_exact&&ca.cr=689543215849&ca.kw=cox%20fiber%20internet%20pricing&ca.mt=e&ca.mp=Google&cb.device=c&ca.tar",
    "chamberProfile": "",
    "memberSince": "2024"
  },
  {
    "name": "digiPETE Website and Graphic Design",
    "category": "Marketing & Business Services",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "619-993-7337",
    "website": "http://digipete.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_digiPETE",
    "memberSince": "2022"
  },
  {
    "name": "Duke's Roadhouse",
    "category": "Food & Drink",
    "location": "19395 N John Wayne Pkwy, Maricopa, AZ 85139",
    "phone": "520-213-8005",
    "website": "http://Dukesroad.house",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_DukesRHouse",
    "memberSince": "2026"
  },
  {
    "name": "Eden Brooks Childcare",
    "category": "Education & Childcare",
    "location": "43571 Courtney Drive, Maricopa, AZ 85139",
    "phone": "505-210-0511",
    "website": "",
    "chamberProfile": "",
    "memberSince": "2026"
  },
  {
    "name": "Electrical District No. 3",
    "category": "Utilities & Communications",
    "location": "41630 W. Louis Johnson Dr., 41664 W. Smith Enke Rd., Ste 100, Maricopa, AZ 85138",
    "phone": "520-424-9021",
    "website": "http://www.ed3online.org",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_ed3online",
    "memberSince": "2023"
  },
  {
    "name": "Enara Law, PLLC",
    "category": "Legal & Financial",
    "location": "7631 E Greenway Rd, Scottsdale, AZ 85260",
    "phone": "602-702-3000",
    "website": "http://www.enaralaw.com",
    "chamberProfile": "",
    "memberSince": "2025"
  },
  {
    "name": "Energy Transfer",
    "category": "Utilities & Communications",
    "location": "8111 Westchester Drive, Suite# 600, Dallas, TX 75225",
    "phone": "214-840-5534",
    "website": "http://www.energytransfer.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_ETMACC",
    "memberSince": "2026"
  },
  {
    "name": "Finishing Touch Cleaning",
    "category": "Home Services",
    "location": "17805 N PORTER RD, Unit J2, Maricopa, AZ 85138",
    "phone": "520-568-9573",
    "website": "",
    "chamberProfile": "",
    "memberSince": "2026"
  },
  {
    "name": "First Things First",
    "category": "Community & Nonprofit",
    "location": "PO Box 11576, Casa Grande, AZ 85130",
    "phone": "480-297-4816",
    "website": "http://www.firstthingsfirst.org",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_FTFAZ",
    "memberSince": "2026"
  },
  {
    "name": "FLATZ520",
    "category": "Real Estate & Housing",
    "location": "45760 W VILLAGE PKWY, Maricopa, AZ 85139",
    "phone": "520-686-2535",
    "website": "http://www.flatz520.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_flatz520",
    "memberSince": "2024"
  },
  {
    "name": "GFB Legal & Notary Services",
    "category": "Legal & Financial",
    "location": "41263 West Somerset Drive, Maricopa, AZ 85138",
    "phone": "206-841-7157",
    "website": "http://www.gfblegal.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_GFBlegal",
    "memberSince": "2025"
  },
  {
    "name": "Global Water Resources",
    "category": "Utilities & Communications",
    "location": "22590 N Powers Pkwy, Maricopa, AZ 85138",
    "phone": "866-940-1102",
    "website": "http://www.gwresources.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_GlobalWr",
    "memberSince": "2006"
  },
  {
    "name": "Glover Court Solutions & Estate Planning",
    "category": "Legal & Financial",
    "location": "41704 W. Smith Enke Road, Suite 100, Maricopa, AZ 85138",
    "phone": "(520) 450-1715",
    "website": "http://www.glovercourtsolutions.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_legaldocuments",
    "memberSince": "2025"
  },
  {
    "name": "Hampton Edison",
    "category": "Professional Services",
    "location": "45305 W. Edison Rd., Leasing Office, Maricopa, AZ 85139",
    "phone": "520-208-2038",
    "website": "http://www.hamptonedison.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_hamptonedison",
    "memberSince": "2024"
  },
  {
    "name": "Hands of Love International",
    "category": "Community & Nonprofit",
    "location": "PO Box 181, Maricopa, AZ 85139",
    "phone": "602-762-2245",
    "website": "http://www.handsofloveinternational.org/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_HOLI",
    "memberSince": "2025"
  },
  {
    "name": "Hendershot Construction & Restoration LLC",
    "category": "Home Services",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "480-375-8969",
    "website": "http://hendershotconstructionllc.com/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_Hendershot",
    "memberSince": "2025"
  },
  {
    "name": "Home at Maricopa",
    "category": "Real Estate & Housing",
    "location": "17645 N Porter Rd, Leasing Office, Maricopa, AZ 85138",
    "phone": "520-413-0710",
    "website": "http://www.homeatmaricopa.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_homeatmaricopa",
    "memberSince": "2024"
  },
  {
    "name": "Hospice of the Valley",
    "category": "Health & Care",
    "location": "1510 E. Flower St., Phoenix, AZ 85014",
    "phone": "602-636-2235",
    "website": "http://www.hov.org",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_hovalley",
    "memberSince": "2022"
  },
  {
    "name": "Impressive Imaging, LLC",
    "category": "Marketing & Business Services",
    "location": "44480 Honeycutt Rd Ste 102, Maricopa, AZ 85138",
    "phone": "520-568-3098",
    "website": "http://www.impressiveimaging.net",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_iillc",
    "memberSince": "2008"
  },
  {
    "name": "Invenergy LLC",
    "category": "Utilities & Communications",
    "location": "5001 E Main Street #1571, Mesa, AZ 85205",
    "phone": "715-573-7815",
    "website": "http://www.invenergy.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_invenergyllcaz",
    "memberSince": "2024"
  },
  {
    "name": "J. Warren Funeral Services Maricopa",
    "category": "Professional Services",
    "location": "525 N Peart Rd., Suite# 101, Casa Grande, AZ 85122",
    "phone": "520-709-8859",
    "website": "http://www.jwarrenfuneral.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_jwarrenfuneral",
    "memberSince": "2015"
  },
  {
    "name": "James Sanson - Real Broker",
    "category": "Real Estate & Housing",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "520-838-8037",
    "website": "http://maricopahomesforsale.com/",
    "chamberProfile": "",
    "memberSince": "2026"
  },
  {
    "name": "Jonathan Willard",
    "category": "Community & Nonprofit",
    "location": "44911 W. Rhea Rd, Maricopa, AZ 85139",
    "phone": "216-849-1063",
    "website": "",
    "chamberProfile": "",
    "memberSince": "2026"
  },
  {
    "name": "K'Bella Spa & Wellness",
    "category": "Health & Care",
    "location": "45004 W. Garvey Ave, Maricopa, AZ 85139",
    "phone": "520-233-8576",
    "website": "http://kbellaspa.com",
    "chamberProfile": "",
    "memberSince": "2026"
  },
  {
    "name": "Karsten's ACE Hardware",
    "category": "Shopping",
    "location": "21542 N John Wayne Pkwy, Maricopa, AZ 85139",
    "phone": "480-252-8768",
    "website": "http://www.maricopaace.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_KARSTEN",
    "memberSince": "2021"
  },
  {
    "name": "La Frontera EMPACT-SPC",
    "category": "Health & Care",
    "location": "21476 N John Wayne Pkwy, Ste C101, Maricopa, AZ 85139",
    "phone": "520-316-6068",
    "website": "http://www.EMPACT-SPC.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_EMPACT-SPC",
    "memberSince": "2024"
  },
  {
    "name": "Linear Scoops",
    "category": "Food & Drink",
    "location": "41293 W. Arvada Lane, Maricopa, AZ 85138",
    "phone": "602-376-2432",
    "website": "http://linearscoops.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_LinearScoops",
    "memberSince": "2025"
  },
  {
    "name": "LitTLE 6 Industries",
    "category": "Professional Services",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "480-231-0323",
    "website": "",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_little6i",
    "memberSince": "2021"
  },
  {
    "name": "Little whiskers animal rescue",
    "category": "Pets & Animal Care",
    "location": "45344 w alamendras st, Maricopa, AZ 85139",
    "phone": "520-371-1553",
    "website": "",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_littlewhiskers",
    "memberSince": "2024"
  },
  {
    "name": "Lizard Heights Glass, LLC",
    "category": "Home Services",
    "location": "20987 N John Wayne Pkwy, Maricopa, AZ 85139",
    "phone": "520-868-6180",
    "website": "http://www.lizardhg.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_glass4u",
    "memberSince": "2006"
  },
  {
    "name": "Mandy's Wine Bar",
    "category": "Food & Drink",
    "location": "41600 W Smith Enke Rd ste 120, Maricopa, AZ 85138",
    "phone": "520-728-4248",
    "website": "http://www.mandyswinebar.com/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_mandyswinebar",
    "memberSince": "2024"
  },
  {
    "name": "Maricopa Cleaners",
    "category": "Home Services",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "520-840-1630",
    "website": "http://maricopacleaners.com/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_Maricopaclean",
    "memberSince": "2024"
  },
  {
    "name": "Maricopa Eye Care",
    "category": "Health & Care",
    "location": "21300 N John Wayne Pkwy, Suite 119, Maricopa, AZ 85139",
    "phone": "520-568-7538",
    "website": "http://www.maricopaeyecare.com",
    "chamberProfile": "",
    "memberSince": "2008"
  },
  {
    "name": "Maricopa First Friday",
    "category": "Recreation & Entertainment",
    "location": "Heritage District, Maricopa, AZ",
    "phone": "520-568-9573",
    "website": "",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_MFFD",
    "memberSince": "2026"
  },
  {
    "name": "Maricopa Monitor",
    "category": "Marketing & Business Services",
    "location": "19428 N. Maricopa Rd Ste 103, Maricopa, AZ 85139",
    "phone": "520-568-4298",
    "website": "https://www.pinalcentral.com/maricopa_monitor/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_MMonitor",
    "memberSince": "2024"
  },
  {
    "name": "Maricopa Pantry",
    "category": "Community & Nonprofit",
    "location": "4660 N Hidden Valley Rd, Maricopa, AZ 85139",
    "phone": "520-709-3076",
    "website": "",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_maricopapantry",
    "memberSince": "2016"
  },
  {
    "name": "Maricopa Police Foundation",
    "category": "Community & Nonprofit",
    "location": "PO Box 1427, Maricopa, AZ 85139",
    "phone": "520-560-1500",
    "website": "http://maricopapolicefoundation.com/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_mpolice",
    "memberSince": "2022"
  },
  {
    "name": "Maricopa Self Storage",
    "category": "Home Services",
    "location": "20125 N Maricopa Rd, Maricopa, AZ 85139",
    "phone": "520-568-1999",
    "website": "http://www.storage-solutions.org",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_MSS",
    "memberSince": "2008"
  },
  {
    "name": "Maricopa Veterans Memorial Park Task Force",
    "category": "Community & Nonprofit",
    "location": "P.O. Box 152, Maricopa, AZ 85139",
    "phone": "951-575-7722",
    "website": "http://www.MaricopaVeteransMemorialPark.org",
    "chamberProfile": "",
    "memberSince": "2024"
  },
  {
    "name": "Maricopa Water and Ice",
    "category": "Food & Drink",
    "location": "20928 N John Wayne Pkwy Ste C7, Maricopa, AZ 85139",
    "phone": "520-568-4740",
    "website": "http://www.maricopawaterandice.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_mrcwaterandice",
    "memberSince": "2023"
  },
  {
    "name": "Maricopa Welcome Service",
    "category": "Marketing & Business Services",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "303-483-1330",
    "website": "",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_welcomeservice",
    "memberSince": "2024"
  },
  {
    "name": "Maricopa Wellness Center",
    "category": "Health & Care",
    "location": "41600 W. Smith Enke Blvd., Maricopa, AZ 85138",
    "phone": "520-464-6193",
    "website": "http://www.MaricopaWellnessCenter.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_maricopawell",
    "memberSince": "2019"
  },
  {
    "name": "McCloskey Auto Glass",
    "category": "Home Services",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "520-280-3391",
    "website": "",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_mccloskeyautog",
    "memberSince": "2024"
  },
  {
    "name": "McLaughlin Air Conditioning & Heating",
    "category": "Home Services",
    "location": "20987 N John Wayne Pkwy, Suite B 104-202, Maricopa, AZ 85139",
    "phone": "520-213-5021",
    "website": "https://plus.google.com/u/1/101401262195255703706",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_mclaughlin",
    "memberSince": "2014"
  },
  {
    "name": "MedMutual Protect/Kim MacPherson-Miller",
    "category": "Legal & Financial",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "520-431-8152",
    "website": "http://www.medmutualprotect.com/",
    "chamberProfile": "",
    "memberSince": "2025"
  },
  {
    "name": "Nando's Mexican Cafe",
    "category": "Food & Drink",
    "location": "44460 W. Edison Rd, Maricopa, AZ 85138",
    "phone": "520-532-1011",
    "website": "http://nandosmexicancafe.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_nandosmexican",
    "memberSince": "2023"
  },
  {
    "name": "Nautilus Water And Mold Damage Professionals DBA Nautilus Services LLC",
    "category": "Home Services",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "520-858-1925",
    "website": "http://nautiluswaterdamage.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_nautilusservice",
    "memberSince": "2025"
  },
  {
    "name": "Now Pools",
    "category": "Home Services",
    "location": "2733 E. Elm St, Phoenix, AZ 85016",
    "phone": "(602) 560-4554",
    "website": "http://nowpools.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_NowPools",
    "memberSince": "2026"
  },
  {
    "name": "Onyx Oasis Bookstore",
    "category": "Shopping",
    "location": "41279 W. Sanders Way, Maricopa, AZ 85138",
    "phone": "937-239-4151",
    "website": "",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_OOB",
    "memberSince": "2026"
  },
  {
    "name": "Orbitel Communications, L.L.C.",
    "category": "Utilities & Communications",
    "location": "21116 N John Wayne Pkwy, Ste B-9, Maricopa, AZ 85139",
    "phone": "480-895-8084",
    "website": "http://www.orbitelcom.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_OC",
    "memberSince": "2007"
  },
  {
    "name": "Pawsitively Loved Luxury Services LLC",
    "category": "Pets & Animal Care",
    "location": "45025 W Miraflores St, Maricopa, AZ 85139",
    "phone": "907-414-1185",
    "website": "http://www.pawsitivelyloved.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_Pawsitively",
    "memberSince": "2025"
  },
  {
    "name": "Petco",
    "category": "Pets & Animal Care",
    "location": "44400 W. Edison Rd, Maricopa, AZ 85138",
    "phone": "520-607-5037",
    "website": "",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_PETCO",
    "memberSince": "2026"
  },
  {
    "name": "PFS Investments",
    "category": "Legal & Financial",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "408-314-1225",
    "website": "http://www.livemore.net/Christina_Maes",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_Cprimerica",
    "memberSince": "2024"
  },
  {
    "name": "Pinal County Supervisor, District 1",
    "category": "Community & Nonprofit",
    "location": "19955 N Wilson Ave, suite 100, Maricopa, AZ 85139",
    "phone": "520-866-3960",
    "website": "http://www.pinal.gov",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_PCD",
    "memberSince": "2022"
  },
  {
    "name": "Ponderosa Broadband",
    "category": "Utilities & Communications",
    "location": "PO Box 1036, Suite# 100, Maricopa, AZ 85139",
    "phone": "520-900-1910",
    "website": "http://www.ponderosa-broadband.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_ponderosabrdbnd",
    "memberSince": "2025"
  },
  {
    "name": "Pregnancy Care Center of Chandler dba. IMAGE CLEAR ULTRASOUND",
    "category": "Health & Care",
    "location": "590 N Alma School Road, Ste 20, Chandler, AZ 85224",
    "phone": "480-374-2994",
    "website": "https://imageclearultrasound.com/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_PCCICU",
    "memberSince": "2025"
  },
  {
    "name": "Professional Fire Fighters of Maricopa, Local 4561",
    "category": "Community & Nonprofit",
    "location": "45700 W. Edison Rd, Maricopa, AZ 85138",
    "phone": "623-826-3307",
    "website": "",
    "chamberProfile": "",
    "memberSince": "2024"
  },
  {
    "name": "Rene Chavez Insurance Agency and Financial Services",
    "category": "Legal & Financial",
    "location": "41620 w Maricopa - Casa Grande Hwy, Suite 105, Maricopa, AZ 85138",
    "phone": "480-495-4008",
    "website": "",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_SFRENECHAVES",
    "memberSince": "2025"
  },
  {
    "name": "RIDE347",
    "category": "Automotive & Transportation",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "602-828-0826",
    "website": "http://www.RIDE347.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_RIDE347",
    "memberSince": "2024"
  },
  {
    "name": "Roof Geeks LLC",
    "category": "Home Services",
    "location": "43830 W Wolf Dr, Maricopa, AZ 85138",
    "phone": "602-679-2957",
    "website": "http://roofgeeksaz.com/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_RoofGeeks",
    "memberSince": "2024"
  },
  {
    "name": "Sandy Hopkins Realtor",
    "category": "Real Estate & Housing",
    "location": "41600 W. Smith Enke Rd., Building 2, Suite 110, Maricopa, AZ 85138",
    "phone": "520-213-3096",
    "website": "http://maricopasandy.com",
    "chamberProfile": "",
    "memberSince": "2026"
  },
  {
    "name": "SRP",
    "category": "Utilities & Communications",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "602-236-5900",
    "website": "http://www.srpnet.com",
    "chamberProfile": "",
    "memberSince": "2023"
  },
  {
    "name": "Start Right Bookkeeping, LLC",
    "category": "Legal & Financial",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "602-481-8117",
    "website": "https://www.startrightbookkeeping.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_startrightbooks",
    "memberSince": "2024"
  },
  {
    "name": "State Farm Insurance- Courtny Tyler",
    "category": "Legal & Financial",
    "location": "41600 W Smith Enke Rd, Bldg 14, Ste 1, Maricopa, AZ 85138",
    "phone": "520-568-5588",
    "website": "http://www.MaricopaInsurance.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_StateFarm",
    "memberSince": "2005"
  },
  {
    "name": "Stepping Stones Learning Center, LLC",
    "category": "Education & Childcare",
    "location": "19756 N Maricopa Road, suite 104, Maricopa, AZ 85139",
    "phone": "520-705-7476",
    "website": "http://www.steppingstonesmaricopa.com",
    "chamberProfile": "",
    "memberSince": "2026"
  },
  {
    "name": "The Dog Gals, LLC",
    "category": "Pets & Animal Care",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "480-606-8664",
    "website": "",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_doggals",
    "memberSince": "2024"
  },
  {
    "name": "The Duke at Rancho El Dorado",
    "category": "Recreation & Entertainment",
    "location": "42660 Rancho El Dorado Pkwy, Maricopa, AZ 85138",
    "phone": "480-844-1100",
    "website": "http://www.thedukegolf.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_TheDukeatRanch",
    "memberSince": "2024"
  },
  {
    "name": "The Maids in Maricopa",
    "category": "Home Services",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "602-805-0300",
    "website": "http://www.maids.com/313",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_maidsofmaricopa",
    "memberSince": "2021"
  },
  {
    "name": "The Maricopa Real Estate Company",
    "category": "Real Estate & Housing",
    "location": "21300N John Wayne Pkwy Ste 101, Maricopa, AZ 85139",
    "phone": "520-350-1091",
    "website": "http://www.tmreco.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_TMRECO",
    "memberSince": "2023"
  },
  {
    "name": "Title Services of the Valley",
    "category": "Real Estate & Housing",
    "location": "45700 W. Edison Rd Ste 110, Maricopa, AZ 85138",
    "phone": "520-524-3393",
    "website": "http://www.tsvaz.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_tsvaz",
    "memberSince": "2025"
  },
  {
    "name": "United Way of Pinal County",
    "category": "Community & Nonprofit",
    "location": "1269 N Promenade Parkway #104, Casa Grande, AZ 85194",
    "phone": "480-836-0736",
    "website": "http://www.unitedwayofpc.org",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_UNITEDWAYofPC",
    "memberSince": "2021"
  },
  {
    "name": "VFW Post 12043",
    "category": "Community & Nonprofit",
    "location": "PO Box 152, 41614 W Smith-Enke Rd. Suiite 110, Maricopa, AZ 85138",
    "phone": "520-424-1914",
    "website": "http://maricopaveteranscenter.org",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_vfwaz12043",
    "memberSince": "2007"
  },
  {
    "name": "Virata",
    "category": "Real Estate & Housing",
    "location": "42584 W Maricopa-Casa Grande Hwy, Maricopa, AZ 85138",
    "phone": "520-317-7678",
    "website": "http://www.viratamaricopa.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_Viratamaricopa",
    "memberSince": "2026"
  },
  {
    "name": "Waste Connections of Arizona",
    "category": "Utilities & Communications",
    "location": "3755 South Royal Palm Road, Apache Junction, AZ 85119",
    "phone": "480-983-9100",
    "website": "https://www.wasteconnections.com/arizona/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_RADMaricopa",
    "memberSince": "2019"
  },
  {
    "name": "Wild Lily Floral",
    "category": "Shopping",
    "location": "Serving Maricopa and Western Pinal County",
    "phone": "224-430-1709",
    "website": "http://wildlilyfloral.com",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_WildLilyFlora",
    "memberSince": "2026"
  },
  {
    "name": "ZenBusiness",
    "category": "Marketing & Business Services",
    "location": "5511 Parkcrest Drive, Suite 103, Austin, TX 78731",
    "phone": "844-493-6249",
    "website": "https://www.zenbusiness.com/arizona-llc/",
    "chamberProfile": "https://maricopa.chamberofcommerce.me/maricopachamber/mem_zenbusinessautx",
    "memberSince": "2021"
  }
];
